/**
 * EmojiPicker (06 §4.11). The spec calls for @emoji-mart/react lazy-loaded; to
 * keep the demo dependency-light and instantly runnable we ship a compact native
 * grid with the same surface (onPick / onClose, themed, inserts at caret).
 * Swapping in emoji-mart only changes this component's internals.
 */
import { useEffect, useRef } from 'react';
import styles from './EmojiPicker.module.css';

const EMOJIS = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😎', '🤔', '😐',
  '😴', '😭', '😡', '👍', '👎', '👏', '🙌', '🙏', '💪', '🔥',
  '🎉', '✨', '❤️', '💔', '💯', '✅', '❌', '👀', '🚀', '🤝',
  '😅', '😇', '🥳', '😱', '🤗', '🫶', '👌', '🤞', '💬', '📷',
];

interface Props {
  onPick: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onPick, onClose }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    window.addEventListener('mousedown', h);
    return () => window.removeEventListener('mousedown', h);
  }, [onClose]);

  return (
    <div ref={ref} className={styles.picker} role="dialog" aria-label="Emoji picker">
      <div className={styles.grid}>
        {EMOJIS.map((e, i) => (
          <button key={i} className={styles.emoji} onClick={() => onPick(e)} aria-label={`Emoji ${e}`}>
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
